export const setSnackbar = (payload) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SNACKBAR',
      payload: payload
    });
  };
};
